import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import TripApp from "../app/TripApp";
import "../app/globals.css";

createRoot(document.getElementById("root")!).render(<StrictMode><TripApp /></StrictMode>);
